import { render, staticRenderFns } from "./TripPageHeader.vue?vue&type=template&id=baa8a2d4"
import script from "./TripPageHeader.vue?vue&type=script&lang=js"
export * from "./TripPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports